import AppServiceLatency from '@bumble/app/assets/appservice-latency.gif';
import EndpointLatency from '@bumble/app/assets/endpoint-latency.gif';
import { Loading } from '@bumble/app/components/Loading';
import { RefreshButton } from '@bumble/app/components/RefreshButton';
import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';
import {
  Box,
  Divider,
  Stack,
  Typography
} from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

interface TestReachabilityProps {
  type: 'endpoint' | 'service';
  id: string;
}
export const TestReachability = ({ type, id }: TestReachabilityProps) => {
  const api = useApi();
  const [latencyData, setLatencyData] = useState<any>(null);

  const AppServiceReachabilityPost = useMutation(api.measureAppServiceLatencyApiV1MeasureAppServiceLatencyPost, {
    onSuccess(data) {
      setLatencyData(data);
    },
    onError: apiError,
  });

  const EndpointReachabilityPost = useMutation(api.measureEpLatencyApiV1MeasureEndpointLatencyPost, {
    onSuccess(data) {
      setLatencyData(data);
    },
    onError: apiError,
  });

  const testReachability = () => {
    setLatencyData(null);
    if (type === 'endpoint') {
      EndpointReachabilityPost.mutate({
        ep_id: id,
      });
    }

    if (type === 'service') {
      AppServiceReachabilityPost.mutate({
        app_service_id: id,
      });
    }
  };

  useEffect(() => {
    testReachability();
  }, []);

  const handleRefreshClick = () => {
    testReachability();
  };

  const isLoading = AppServiceReachabilityPost.isLoading || EndpointReachabilityPost.isLoading;

  return (
    <Box>
      <Box
        component="img"
        src={type === 'service' ? AppServiceLatency : EndpointLatency}
        alt={type === 'service' ? 'App Service Latency' : 'Endpoint Latency'}
        sx={{
          width: '100%',
          height: 'auto',
          maxWidth: '100%',
          objectFit: 'cover',
        }}
      />
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h4" color="primary">Latency Data</Typography>
        <RefreshButton onRefresh={handleRefreshClick} />
      </Box>
      <Divider sx={{ my: 2 }} />
      {!latencyData && isLoading && <Loading />}
      {latencyData && (
        <Stack spacing={2}>
          {latencyData &&
            latencyData?.data &&
            Object.entries(latencyData.data).map(([key, val]) => (
              <Stack direction="row" spacing={2} alignItems="center" key={key}>
                <Typography variant="subtitle1">{key.charAt(0).toUpperCase() + key.slice(1)}:</Typography>
                {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
                {/* @ts-ignore */}
                <Typography variant="body2">{val}</Typography>
              </Stack>
            ))}
        </Stack>
      )}
    </Box>
  );
};
